import { FBA_announcementsInbox, FBA_announcementsTool, orgAdmin } from 'common/constants/permissions';

const canViewAnnouncementsTool = permissions => !!permissions[orgAdmin] && !!permissions[FBA_announcementsTool];
const canViewAnnouncements = permissions => !!permissions[FBA_announcementsInbox];

export default {
    canViewAnnouncementsTool,
    canViewAnnouncements
};
